import { render, staticRenderFns } from "./veStuLiteraryAwardShen.vue?vue&type=template&id=3d20f9d8&scoped=true"
import script from "./veStuLiteraryAwardShen.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20f9d8",
  null
  
)

export default component.exports